import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import * as Yup from 'yup';
import DatePicker from 'react-datepicker'
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import { useContext, useEffect, useState } from "react";
import Get from "../../api/Get";
import { authContext } from "../../context/AuthContext";

import 'react-phone-input-2/lib/style.css'
import { ACCOUNT_ACTIVE_ALL, COMPANY_ALL_ACTIVE, COUNTRY_ACTIVE_ALL, LANGUAGE_ACTIVE_ALL, MARITAL_STATUS_ALL, MUNICIPIO_LIST, PACIENTERELACION_GET_ACTIVE, RELIGIONES_ALL, STATES_LIST, UPDATE_APPOINTMENT } from "../../api/Routes";
import { Field, Formik } from "formik";
import moment from "moment";
import SelectEstado from "../SelectEstado";
import Select from "react-select";
import SimpleLoad from "../../loader/SimpleLoad";
import Put from "../../api/Put";
import ComponentModalErrorSever from "../ComponentModalErrorSever";



function ComponentModalPacienteMexico({ t, data, showModal, handleClose, setCita }) {
    console.log('Data paciente', data)
    const { auth } = useContext(authContext)
    const [accountsAll, setAccountsAll] = useState([])
    const [companyOpt, setCompanyOpt] = useState([])
    const [countryOpt, setCountryOpt] = useState([])
    const [languageOpt, setLanguageOpt] = useState([])
    const [maritalStatusOpt, setMaritalStatusOpt] = useState([])
    const [religionOpt, setReligionOpt] = useState([])
    const [tipoPacientes, setTipoPacientes] = useState([])
    const [estadoAll, setEstadoAll] = useState([])
    const [estadoOpt, setEstadoOpt] = useState([])
    const [municipioAll, setMunicipioAll] = useState([])
    const [municipioOpt, setMunicipioOpt] = useState([])
    const [accountDefault, setAccountdefault] = useState(null)
    const [partnerDefault, setPartnerDefault] = useState(null)
    const [dateOfBirthday, setDateOfBirthday] = useState(null)
    const [phone, setPhone] = useState('')
    const [phone2, setPhone2] = useState('')
    const [paisDefault, setPaisDefault] = useState(null)
    const [estadoDefault, setEstadoDefault] = useState(null)
    const [municipioDefault, setMunicipioDefault] = useState(null)

    //error server
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleCloseServer = () => setShowModalError(false)

    const [initialValues, setInitialValues] = useState({
        id: '',
        name: '',
        curp: '',
        middleName: '',
        seccondSurname: '',
        lastName: '',
        gender: '',
        dateOfBirthday: '',
        maritalStatus: '',
        nationality: '',
        phoneNumber: '',
        phoneNumber2: '',
        email: '',
        country: '',
        religion: '',
        bloodType: '',
        occupation: '',
        language: '',
        address: '',
        allergies: '',
        account: '',
        company: '',
        medicalHistory: '',
        externalId: '',
        cp: '',
        municipio: '',
        state: '',
        patientRelationship: '',
        peso: '',
        talla: '',
        motivoConsulta: '',
        derechohabiencia: ['0'],
        programaSMyMG: 0,
        /*primeraVezAnio: '',
       primeraVezUnemeSaih: '',
       tipoDificultad: '',
       gradoDificultad: '',
       origenDificultad: '',*/
        seConsideraIndigena: '2',
        seAutodenominaAfromexicano: '2',
        migrante: '-1',
    })

    //console.log(data)

    useEffect(() => {

        //console.log(data)
        if (data) {
            let entity = {
                id: data.id,
                name: data.name,
                curp: data.curp,
                middleName: data.middleName ? data.middleName : '',
                seccondSurname: data.seccondSurname ? data.seccondSurname : '',
                lastName: data.lastName,
                gender: data.gender,
                dateOfBirthday: data.dateOfBirthday ? new Date(moment(data.dateOfBirthday, 'DD-MM-YYYY')) : '',
                maritalStatus: data.maritalStatus?.id,
                nationality: data.nationality,
                phoneNumber: data.phoneNumber,
                phoneNumber2: data.phoneNumber2,
                email: data.email,
                country: data.country?.id,
                religion: data.religion?.id,
                bloodType: data.bloodType,
                occupation: data.occupation,
                language: data.language?.id,
                address: data.address,
                allergies: data.allergies,
                account: data.account?.id,
                company: data.company?.id,
                medicalHistory: data.medicalHistory,
                externalId: data.externalId,
                cp: data.cp,
                municipio: data.municipio?.id,
                state: data.state?.id,
                patientRelationship: data.patientRelationship?.id,
                peso: data.peso,
                talla: data.talla,
                motivoConsulta: data.motivoConsulta,
                derechohabiencia: Array.isArray(data.derechohabiencia) ? data.derechohabiencia : [data.derechohabiencia],
                programaSMyMG: data.programaSMyMG || '0',
                /*primeraVezAnio: data.primeraVezAnio,
                primeraVezUnemeSaih: data.primeraVezUnemeSaih,
                tipoDificultad: data.tipoDificultad,
                gradoDificultad: data.gradoDificultad,
                origenDificultad: data.origenDificultad,*/
                seConsideraIndigena: data?.seConsideraIndigena,
                seAutodenominaAfromexicano: data?.seAutodenominaAfromexicano,
                migrante: data?.migrante,
            }
            setDateOfBirthday(entity.dateOfBirthday ? new Date(moment(entity.dateOfBirthday, 'DD-MM-YYYY')) : new Date())
            setPhone(data.phoneNumber ?? '')
            setPhone2(data.phoneNumber2 ?? '')
            if (data.country) {
                setIdCountry(data.country?.id)
                setPaisDefault({ label: data.country.name, value: data.country.id })
            }
            if (data.state) {
                setEstadoDefault({ label: data.state.name, value: data.state.id })
                setIdEstado(data.state.id)
            }
            if (data.municipio) {
                setMunicipioDefault({ label: data.municipio.dsMunDel, value: data.municipio.id })
            }
            setPartnerDefault(data.account ? data.account.partner.name : '')
            setAccountdefault({ label: data.account.name, value: data.account.id })
            setInitialValues(entity)
        }
    }, [data])
    //const curpRegExp = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/g;
    //const curpRegExp = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS|XX)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/g;
    const curpRegExp = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
    const specialCaseRegExp = /^XXXX999999XXXXXX99$/;
    const shemaValidate = Yup.object().shape({
        motivoConsulta: Yup.string()
            .required(t('Camporequerido')),
        name: Yup.string()
            .required(t('Camporequerido')),
        curp: Yup.string()
            .required(t('Camporequerido'))
            .test('curp', 'Curp inválido', (value) => {
                return curpRegExp.test(value) || specialCaseRegExp.test(value);
            }),
        lastName: Yup.string()
            .required(t('Camporequerido')),
        patientRelationship: Yup.string()
            .required(t('Camporequerido')),
        gender: Yup.string()
            .required(t('Camporequerido')),
        dateOfBirthday: Yup.string()
            .required(t('Camporequerido')),
        // nationality: Yup.string()
        //   .required(t('Camporequerido')),
        phoneNumber: Yup.string()
            .required(t('Camporequerido'))
            .min(12, 'Campo inválido')
            .max(12, 'Campo inválido'),
        /*phoneNumber2: Yup.string()
            .required(t('Camporequerido'))
            .min(12, 'Campo inválido')
            .max(12, 'Campo inválido'),*/
        email: Yup.string()
            .email(t('Correoinvalido'))
            .required(t('Camporequerido')),
        maritalStatus: Yup.string()
            .required(t('Camporequerido')),
        country: Yup.string()
            .required(t('Camporequerido')),
        cp: Yup.string()
            .required(t('Camporequerido')),
        municipio: Yup.string()
            .required(t('Camporequerido')),
        state: Yup.string()
            .required(t('Camporequerido')),
        /*religion: Yup.string()
            .required(t('Camporequerido')),*/
        derechohabiencia: Yup.array()
            .test('test-name', 'Selección no válida', function (value) {
                if (!value) return true; // Not required
                if (value.includes('0') || value.includes('1') || value.includes('99')) {
                    return value.length === 1; // If '0', '1', or '99' is selected, no other option should be selected
                }
                return true; // Otherwise, multiple selections are allowed
            }),
        // bloodType: Yup.string()
        //   .required(t('Camporequerido')),
        // occupation: Yup.string()
        //   .required(t('Camporequerido')),
        language: Yup.string()
            .required(t('Camporequerido')),
        // address: Yup.string()
        //   .required(t('Camporequerido')),
        // allergies: Yup.string()
        //   .required(t('Camporequerido')),
        account: Yup.string()
            .required(t('Camporequerido')),
        company: Yup.string()
            .required(t('Camporequerido')),

    });


    useEffect(() => {
        let mounted = true
        Get({ url: ACCOUNT_ACTIVE_ALL, access_token: auth.data.access_token })
            .then(response => {
                if (mounted) {
                    setAccountsAll(response.data.data.response)
                }
            }).catch(error => {
                setShowModalError(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
        Get({ url: COMPANY_ALL_ACTIVE, access_token: auth.data.access_token })
            .then(response => {
                if (mounted) {
                    setCompanyOpt(response.data.data.response)
                }
            }).catch(error => {
                setShowModalError(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
        Get({ url: COUNTRY_ACTIVE_ALL, noToken: true })
            .then(response => {
                //console.log(response)
                if (mounted) {
                    setCountryOpt(response.data.data.response.map(el => ({ label: el.name, value: el.id })))
                }
            }).catch(error => {
                setShowModalError(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
        Get({ url: LANGUAGE_ACTIVE_ALL, access_token: auth.data.access_token })
            .then(response => {
                if (mounted) {
                    setLanguageOpt(response.data)
                }
            }).catch(error => {
                setShowModalError(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
        Get({ url: MARITAL_STATUS_ALL, access_token: auth.data.access_token })
            .then(response => {
                if (mounted) {
                    setMaritalStatusOpt(response.data.data.response.content)
                }
            }).catch(error => {
                setShowModalError(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
        Get({ url: RELIGIONES_ALL, access_token: auth.data.access_token })
            .then(response => {
                if (mounted) {
                    setReligionOpt(response.data.data.response.content)
                }
            }).catch(error => {
                setShowModalError(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
        Get({ url: PACIENTERELACION_GET_ACTIVE, access_token: auth.data.access_token })
            .then(response => {
                if (mounted) {
                    setTipoPacientes(response.data.data.response)
                }
            })
            .catch(error => {
                setShowModalError(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
        return () => mounted = false;
    }, [])

    useEffect(() => {
        setEstadoOpt(estadoAll.filter(el => el.country?.id === initialValues.country))
        setMunicipioOpt(municipioAll.filter(el => el.state?.id === initialValues.state))
    }, [initialValues, municipioAll, estadoAll])

    //si cambia el pais
    const [idCountry, setIdCountry] = useState(null)
    useEffect(() => {
        if (idCountry) {
            let mounted = true;
            Get({ url: `${STATES_LIST}/${idCountry}`, access_token: auth.data.access_token })
                .then(response => {
                    if (mounted) {
                        setEstadoOpt(response.data.data.response.map(el => ({ label: el.name, value: el.id })))
                    }
                })
                .catch(error => {
                    setEstadoOpt([])
                    setShowModalError(true)
                    if (error.response) {
                        setErrorServer(error.response)
                    }
                })
            return () => mounted = false;
        } else {
            setEstadoOpt([])
        }

    }, [idCountry])

    //si cambia el estado
    const [idEstado, setIdEstado] = useState(null)
    useEffect(() => {
        if (idEstado) {
            let mounted = true;
            Get({ url: `${MUNICIPIO_LIST}/${idEstado}`, access_token: auth.data.access_token })
                .then(response => {
                    if (mounted) {
                        setMunicipioOpt(response.data.data.response.map(el => ({ label: el.dsMunDel, value: el.id })))
                    }
                })
                .catch(error => {
                    setMunicipioOpt([])
                })
            return () => mounted = false;
        } else {
            setMunicipioOpt([])
        }
    }, [idEstado])

    //si cambia el account para q sepa cual es el partner==="cliente corporativo"
    useEffect(() => {
        if (accountDefault) {
            let itemsF = accountsAll.filter(el => el.id === accountDefault.value)
            if (itemsF.length) {
                setPartnerDefault(itemsF[0].partner.name)
            }
        }
    }, [accountDefault])


    return (
        <>
            <Modal show={showModal} size="lg" onHide={handleClose} dialogClassName="modal-90w" backdrop="static" keyboard={false}>
                <Modal.Header closeButton className="border-0"></Modal.Header>
                <Modal.Body className="px-3 overflow-hidden">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={shemaValidate}
                        enableReinitialize
                        onSubmit={(values, { setSubmitting, setFieldValue }) => {
                            //console.log(estadoDefault)
                            //console.log(municipioDefault)
                            let acc = accountsAll.filter(e => e.id === accountDefault.value)
                            let patient = {
                                id: values.id,
                                account: acc[0],
                                address: values.address,
                                allergies: values.allergies,
                                bloodType: values.bloodType,
                                company: { id: values.company },
                                country: { id: paisDefault.value, name: paisDefault.label },
                                dateOfBirthday: moment(values.dateOfBirthday).format('DD-MM-YYYY'),
                                email: values.email,
                                gender: values.gender,
                                language: { id: values.language },
                                lastName: values.lastName,
                                maritalStatus: { id: values.maritalStatus },
                                medicalHistory: values.medicalHistory,
                                name: values.name,
                                curp: values.curp,
                                derechohabiencia: values.derechohabiencia,
                                seConsideraIndigena: values.seConsideraIndigena,
                                seAutodenominaAfromexicano: values.seAutodenominaAfromexicano,
                                migrante: values.migrante,
                                middleName: values.middleName,
                                seccondSurname: values.seccondSurname,
                                nationality: values.nationality,
                                isNewPatient: false,
                                occupation: values.occupation,
                                phoneNumber: values.phoneNumber,
                                /*phoneNumber2: values.phoneNumber2,
                                religion: { id: values.religion },*/
                                phoneNumber2: values.phoneNumber2 ? values.phoneNumber2 : '',
                                religion: typeof values.religion === 'string' && values.religion.trim() !== '' ? { id: values.religion } : null,
                                password: '123456',
                                autoagendamiento: false,
                                externalId: values.externalId,
                                cp: values.cp,
                                municipio: { id: municipioDefault.value, dsMunDel: municipioDefault.label },
                                state: { id: estadoDefault.value, name: estadoDefault.label },
                                patientRelationship: { id: values.patientRelationship },
                            }
                            let d = {
                                id: data.idCita,
                                patient: patient,
                                peso: values.peso,
                                talla: values.talla,
                                motivoConsulta: values.motivoConsulta
                            }

                            //console.log(d)

                            Put({ url: UPDATE_APPOINTMENT, data: d, access_token: auth.data.access_token, header: true })
                                .then(response => {
                                    //console.log(response)
                                    setSubmitting(false)
                                    setCita(prev => ({
                                        ...prev,
                                        patientDTO: response.data.data.patientDTO,
                                        peso: response.data.data.peso,
                                        talla: response.data.data.talla,
                                        motivoConsulta: response.data.data.motivoConsulta,
                                        imc: response.data.data.imc,
                                        age: response.data.data.age
                                    }))
                                    handleClose()
                                })
                                .catch(error => {
                                    setSubmitting(false)
                                    setShowModalError(true)
                                    if (error.response) {
                                        setErrorServer(error.response)
                                    }
                                })
                        }}
                    >{({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        setFieldError
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            {isSubmitting && <SimpleLoad />}
                            <h4 className="text-color-4">Datos de la cita</h4>
                            <Row>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Peso (kg)</Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form ${errors.peso && 'error'}`}
                                            name="peso"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Talla (cm)</Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form ${errors.talla && 'error'}`}
                                            name="talla"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="8">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Motivo de la consulta <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form ${errors.motivoConsulta && 'error'}`}
                                            name="motivoConsulta"
                                        />
                                        {errors.motivoConsulta && <div className="invalid-feedback d-block">{errors.motivoConsulta}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">¿La atención es brindada por personal contratado para el programa U013 de SM y MG?</Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form ${errors.programaSMyMG && 'error'}`}
                                            name="programaSMyMG"
                                            disabled
                                        >
                                            <option value="0">NO</option>
                                        </Field>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <h4 className="text-color-4">{t('Datosgenerales')}</h4>
                            <Row>
                                <Col xs="12" md="12">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">CURP <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form text-uppercase ${errors.curp && 'error'}`}
                                            name="curp"
                                            onChange={e => {
                                                setFieldValue('curp', e.target.value.toUpperCase());
                                            }}
                                        />
                                        {errors.curp && <div className="invalid-feedback d-block">{errors.curp}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Nombre')} <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form text-uppercase ${errors.name && 'error'}`}
                                            name="name"
                                            onChange={e => {
                                                setFieldValue('name', e.target.value.toUpperCase())
                                            }}
                                        />
                                        {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Segundo nombre</Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form text-uppercase`}
                                            name="middleName"
                                            onChange={e => {
                                                setFieldValue('middleName', e.target.value.toUpperCase())
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Primer apellido <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form text-uppercase ${errors.lastName && 'error'}`}
                                            name="lastName"
                                            onChange={e => {
                                                setFieldValue('lastName', e.target.value.toUpperCase())
                                            }}
                                        />
                                        {errors.lastName && <div className="invalid-feedback d-block">{errors.lastName}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Segundo apellido</Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form text-uppercase`}
                                            name="seccondSurname"
                                            onChange={e => {
                                                setFieldValue('seccondSurname', e.target.value.toUpperCase())
                                            }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Tipo <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form ${errors.patientRelationship && 'error'}`}
                                            name="patientRelationship"
                                        >
                                            <option value="">Seleccionar</option>
                                            {
                                                tipoPacientes.map((item, i) => (
                                                    <option key={i} value={item.id}>{item.name}</option>
                                                ))
                                            }
                                        </Field>
                                        {errors.patientRelationship && <div className="invalid-feedback d-block">{errors.patientRelationship}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('sexo')} <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form ${errors.gender && 'error'}`}
                                            name="gender"
                                        >
                                            <option value="0">No especificado</option>
                                            <option value="Male">{t('Masculino')}</option>
                                            <option value="Female">{t('Femenino')}</option>
                                        </Field>
                                        {errors.gender && <div className="invalid-feedback d-block">{errors.gender}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary d-block">{t("fecha_nacimiento")} <span className="text-danger">*</span></Form.Label>
                                        <DatePicker
                                            className={`form-control input-form w-100 ${errors.dateOfBirthday && 'error'}`}
                                            selected={dateOfBirthday}
                                            dateFormat="dd-MM-yyyy"
                                            maxDate={new Date()}
                                            onChange={date => {
                                                if (date === null) {
                                                    setDateOfBirthday(null)
                                                    setFieldValue('dateOfBirthday', '')
                                                } else {
                                                    setDateOfBirthday(date)
                                                    setFieldValue('dateOfBirthday', date)
                                                }

                                            }} />
                                        {errors.dateOfBirthday && <div className="invalid-feedback d-block">{errors.dateOfBirthday}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="4">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Nacionalidad')}</Form.Label>
                                        <div className="mt-3">
                                            <label className="mr-5 text-color-input">
                                                {t('Mexicana')}
                                                <Field
                                                    type="radio"
                                                    name="nationality"
                                                    value="Mexicana"
                                                    className="ml-3 radio-form"
                                                />
                                            </label>
                                            <label className="mr-5 text-color-input">
                                                {t('Extranjera')}
                                                <Field
                                                    type="radio"
                                                    name="nationality"
                                                    value="Extranjera"
                                                    className="ml-3 radio-form"
                                                />
                                            </label>
                                        </div>
                                        {errors.nationality && <div className="invalid-feedback d-block">{errors.nationality}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t("Estadocivil")} <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form ${errors.maritalStatus && 'error'}`}
                                            name="maritalStatus"
                                        >
                                            <option value="">{t('Seleccionar')}</option>
                                            {
                                                maritalStatusOpt.map((item, i) => (
                                                    <option value={item.id} key={i}>{item.name}</option>
                                                ))
                                            }
                                        </Field>
                                        {errors.maritalStatus && <div className="invalid-feedback d-block">{errors.maritalStatus}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Cuenta usted con seguridad social? (use control+Click para seleccionar varios) </Form.Label>
                                        <Field
                                            style={{ height: '200px' }}
                                            as="select"
                                            className={`form-control ${errors.derechohabiencia && 'error'}`}
                                            name="derechohabiencia"
                                            multiple
                                        >
                                            <option value="0">NO ESPECIFICADO</option>
                                            <option value="1">NINGUNA</option>
                                            <option value="2">IMSS</option>
                                            <option value="3">ISSSTE</option>
                                            <option value="4">PEMEX</option>
                                            <option value="5">SEDENA</option>
                                            <option value="6">SEMAR</option>
                                            <option value="8">OTRA</option>
                                            <option value="10">IMSS BIENESTAR</option>
                                            <option value="11">ISSFAM</option>
                                            <option value="13">INSABI</option>
                                            <option value="99">SE IGNORA</option>
                                        </Field>
                                        {errors.derechohabiencia && <div className="invalid-feedback d-block">{errors.derechohabiencia}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">¿Se considera usted una persona indígena?</Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form`}
                                            name="seConsideraIndigena"
                                        >
                                            <option value="-1">SIN RESPUESTA</option>
                                            <option value="0">NO</option>
                                            <option value="1">SI</option>
                                            <option value="2">NO RESPONDE</option>
                                            <option value="3">NO SABE</option>
                                        </Field>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">¿Se considera usted una persona afroamericana?</Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form`}
                                            name="seAutodenominaAfromexicano"
                                        >
                                            <option value="-1">SIN RESPUESTA</option>
                                            <option value="0">NO</option>
                                            <option value="1">SI</option>
                                            <option value="2">NO RESPONDE</option>
                                            <option value="3">NO SABE</option>
                                        </Field>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">¿Usuario migrante?</Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form`}
                                            name="migrante"
                                        >
                                            <option value="-1">DESCONOCIDO</option>
                                            <option value="0">NO</option>
                                            <option value="1">SI</option>
                                        </Field>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <h4 className="text-color-4">{t("Expediente")}</h4>
                            <Row>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">No. poliza</Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form ${errors.externalId && 'error'}`}
                                            name="externalId"
                                        />
                                        <Form.Text muted>Este campo no es obligatorio</Form.Text>
                                        {errors.externalId && <div className="invalid-feedback d-block">{errors.externalId}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Telefono')} <span className="text-danger">*</span></Form.Label>
                                        <PhoneInput
                                            inputClass={`form-control input-form ${errors.phoneNumber && 'error'} w-100`}
                                            country={'mx'}
                                            countryCodeEditable={false}
                                            enableSearch={true}
                                            preferredCountries={['mx', 'co']}
                                            disableSearchIcon={true}
                                            localization={es}
                                            value={phone}
                                            onChange={(phone, country, e, formattedValue) => {
                                                setPhone(phone)
                                                setFieldValue('phoneNumber', phone)
                                                let validNumber = (country.format.match(/\./g)).length
                                                if (phone.length !== validNumber) {
                                                    setFieldError('phoneNumber', 'Campo inválido')
                                                } else if (phone.length === validNumber) {
                                                    setFieldValue('phoneNumber', phone, true)
                                                }
                                            }}
                                        />
                                        {errors.phoneNumber && <div className="invalid-feedback d-block">{errors.phoneNumber}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Teléfono alterno</Form.Label>
                                        <PhoneInput
                                            inputClass={`form-control input-form ${errors.phoneNumber2 && 'error'} w-100`}
                                            country={'mx'}
                                            countryCodeEditable={false}
                                            enableSearch={true}
                                            preferredCountries={['mx', 'co']}
                                            disableSearchIcon={true}
                                            localization={es}
                                            value={phone}
                                            onChange={(phone, country, e, formattedValue) => {
                                                setPhone2(phone)
                                                setFieldValue('phoneNumber2', phone)
                                                // Remove the country code from the phone number
                                                let phoneNumberWithoutCountryCode = phone.replace(country.dialCode, '');
                                                if (phoneNumberWithoutCountryCode) {
                                                    let validNumber = (country.format.match(/\./g)).length
                                                    if (phoneNumberWithoutCountryCode.length !== validNumber) {
                                                        setFieldError('phoneNumber2', 'Campo inválido')
                                                    } else if (phoneNumberWithoutCountryCode.length === validNumber) {
                                                        setFieldValue('phoneNumber2', phone, true)
                                                    }
                                                } else {
                                                    setFieldError('phoneNumber2', '')
                                                }
                                            }}
                                        />
                                        {errors.phoneNumber2 && <div className="invalid-feedback d-block">{errors.phoneNumber2}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Correoelectronico')} <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form ${errors.email && 'error'}`}
                                            name="email"
                                        />
                                        {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Religion')}</Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form ${errors.religion && 'error'}`}
                                            name="religion"
                                        >
                                            <option value="">{t('Seleccionar')}</option>
                                            {
                                                religionOpt.map((item, i) => (
                                                    <option value={item.id} key={i}>{item.name}</option>
                                                ))
                                            }
                                        </Field>
                                        {errors.religion && <div className="invalid-feedback d-block">{errors.religion}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Código Postal <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form ${errors.cp && 'error'}`}
                                            name="cp"
                                        />
                                        {errors.cp && <div className="invalid-feedback d-block">{errors.cp}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Tiposangre')}</Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form ${errors.bloodType && 'error'}`}
                                            name="bloodType"
                                        >
                                            <option value="">Seleccionar</option>
                                            <option value="O-">O-</option>
                                            <option value="O+">O+</option>
                                            <option value="A-">A-</option>
                                            <option value="A+">A+</option>
                                            <option value="AB-">AB-</option>
                                            <option value="AB+">AB+</option>
                                            <option value="B+">B+</option>
                                            <option value="B-">B-</option>
                                            <option value="desconocido">{t('Desconocido')}</option>
                                        </Field>
                                        {errors.bloodType && <div className="invalid-feedback d-block">{errors.bloodType}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">País <span className="text-danger">*</span></Form.Label>
                                        <Select
                                            className={`input-form ${errors.country && 'error'}`}
                                            options={countryOpt}
                                            defaultValue={paisDefault}
                                            value={paisDefault}
                                            onChange={(value) => {
                                                //console.log(e)
                                                setPaisDefault(value)
                                                setFieldValue("country", value.value)
                                                setMunicipioOpt([])
                                                setFieldValue("municipio", "")
                                                setMunicipioDefault(null)
                                                setFieldValue("state", "")
                                                setEstadoDefault(null)
                                                setIdCountry(value.value)
                                            }}
                                            placeholder="Escoger opción"
                                        />
                                        {errors.country && <div className="invalid-feedback d-block">{errors.country}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Estado <span className="text-danger">*</span></Form.Label>
                                        <Select
                                            className={`input-form ${errors.state && 'error'}`}
                                            options={estadoOpt}
                                            defaultValue={estadoDefault}
                                            value={estadoDefault}
                                            onChange={(value) => {
                                                //console.log(e)
                                                setEstadoDefault(value)
                                                setFieldValue("state", value.value)
                                                setFieldValue("municipio", "")
                                                setMunicipioDefault(null)
                                                setMunicipioOpt([])
                                                setIdEstado(value.value)
                                            }}
                                            placeholder="Escoger opción"
                                        />
                                        {errors.state && <div className="invalid-feedback d-block">{errors.state}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Municipio <span className="text-danger">*</span></Form.Label>
                                        <Select
                                            className={`input-form ${errors.municipio && 'error'}`}
                                            options={municipioOpt}
                                            defaultValue={municipioDefault}
                                            value={municipioDefault}
                                            onChange={(value) => {
                                                //console.log(e)
                                                setMunicipioDefault(value)
                                                setFieldValue("municipio", value.value)
                                            }}
                                            placeholder="Escoger opción"
                                        />
                                        {errors.municipio && <div className="invalid-feedback d-block">{errors.municipio}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('ocupacion')}</Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form ${errors.occupation && 'error'}`}
                                            name="occupation"
                                        />
                                        {errors.occupation && <div className="invalid-feedback d-block">{errors.occupation}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('Idioma')} <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form ${errors.language && 'error'}`}
                                            name="language"
                                        >
                                            <option value="">{t('Seleccionar')}</option>
                                            {
                                                languageOpt.map((item, i) => (
                                                    <option value={item.id} key={i}>{item.name}</option>
                                                ))
                                            }
                                        </Field>
                                        {errors.language && <div className="invalid-feedback d-block">{errors.language}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="4">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('direccion')}</Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form ${errors.address && 'error'}`}
                                            name="address"
                                        />
                                        {errors.address && <div className="invalid-feedback d-block">{errors.address}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('alergias')}</Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form ${errors.allergies && 'error'}`}
                                            name="allergies"
                                        />
                                        {errors.allergies && <div className="invalid-feedback d-block">{errors.allergies}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('historia_medica')}</Form.Label>
                                        <Field
                                            type="text"
                                            className={`form-control input-form ${errors.medicalHistory && 'error'}`}
                                            name="medicalHistory"
                                        />
                                        {errors.medicalHistory && <div className="invalid-feedback d-block">{errors.medicalHistory}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('compania')} <span className="text-danger">*</span></Form.Label>
                                        <Field
                                            as="select"
                                            className={`form-control input-form ${errors.company && 'error'}`}
                                            name="company"
                                        >
                                            <option value="">{t('Seleccionar')}</option>
                                            {
                                                companyOpt.map((item, i) => (
                                                    <option value={item.id} key={i}>{item.name}</option>
                                                ))
                                            }
                                        </Field>
                                        {errors.company && <div className="invalid-feedback d-block">{errors.company}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('cuenta_cliente_corporativo')} <span className="text-danger">*</span></Form.Label>
                                        <Select
                                            className="input-form"
                                            options={accountsAll.map(e => ({ label: e.name, value: e.id }))}
                                            defaultValue={accountDefault}
                                            value={accountDefault}
                                            onChange={e => {
                                                setAccountdefault(e)
                                                setFieldValue('account', e.value)
                                            }}
                                            menuPlacement="top"
                                        />
                                        {errors.account && <div className="invalid-feedback d-block">{errors.account}</div>}
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">Cliente corporativo </Form.Label>
                                        <div className="form-control input-form align-center">{partnerDefault}</div>
                                    </Form.Group>
                                </Col>

                            </Row>

                            <Row>
                                <Col className="text-right">
                                    <Button variant="outline-success" className="ok-buttom" type="submit">Aceptar</Button>{' '}
                                </Col>
                            </Row>
                        </Form>
                    )}
                    </Formik>
                </Modal.Body>
            </Modal>
            <ComponentModalErrorSever
                show={showModalError}
                handleClose={handleCloseServer}
                error={errorServer}
            />
        </>

    )

}

export default withTranslation()(ComponentModalPacienteMexico)